import { primary, secondary, text } from '@/theme/colors/palettes';
import { Box, HStack, Text } from '@chakra-ui/react';

const TeamConcernsLegend = () => (
  <HStack gap={'16px'}>
    <HStack gap={'6px'}>
      <Box width={'11px'} height={'11px'} backgroundColor={secondary[500]} borderRadius={'50%'} />
      <Text variant={'urbanistSmallBold'} color={text.mediumGray} fontWeight={600} fontSize={'14px'}>
        From Peer Support
      </Text>
    </HStack>
    <HStack gap={'6px'}>
      <Box width={'11px'} height={'11px'} backgroundColor={primary[500]} borderRadius={'50%'} />
      <Text variant={'urbanistSmallBold'} color={text.mediumGray} fontWeight={600} fontSize={'14px'}>
        From Screener
      </Text>
    </HStack>
  </HStack>
);

export default TeamConcernsLegend;
